module.exports = __webpack_public_path__ + "img/cooperation_unit_07.480f6645.png";